import { useTranslation } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Map, ShieldCheck, Wallet, Users, ClipboardList, BookOpen, Plane, AlertTriangle, Mic, Heart } from 'lucide-react';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    { icon: Map, title: t('landing.features.planning'), desc: t('landing.features.planningDesc'), color: '#3A86FF' },
    { icon: ShieldCheck, title: t('landing.features.compliance'), desc: t('landing.features.complianceDesc'), color: '#3A86FF' },
    { icon: Wallet, title: t('landing.features.budget'), desc: t('landing.features.budgetDesc'), color: '#00CC99' },
    { icon: Users, title: t('landing.features.sharing'), desc: t('landing.features.sharingDesc'), color: '#F59E0B' },
    { icon: ClipboardList, title: t('landing.features.tasks'), desc: t('landing.features.tasksDesc'), color: '#8B5CF6' },
    { icon: BookOpen, title: t('landing.features.journal'), desc: t('landing.features.journalDesc'), color: '#3A86FF' },
    { icon: Plane, title: 'Import & Sync', desc: 'Import reservations from CSV, TXT or PDF. Lock critical bookings.', color: '#3A86FF' },
    { icon: AlertTriangle, title: 'Plan B / Incident', desc: 'Disruption handling with AI-powered replanning alternatives.', color: '#EF4444' },
    { icon: Mic, title: 'Voice Copilot', desc: 'Ask questions by voice and get instant travel recommendations.', color: '#00CC99' },
    { icon: Heart, title: 'Health & Comfort', desc: 'Medication checklists, fatigue-aware pacing, hydration reminders.', color: '#F59E0B' },
  ];

  return (
    <div className="py-16 md:py-24" data-testid="features-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-[#1E293B] mb-4" >
            {t('features.title')}
          </h1>
          <p className="text-base md:text-lg text-[#64748B] max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((f, i) => (
            <Card key={i} className="group border border-[#E2E8F0]/40 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] transition-all duration-300 rounded-2xl animate-fade-in-up" style={{ animationDelay: `${i * 0.08}s` }}>
              <CardContent className="p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110" style={{ backgroundColor: `${f.color}15` }}>
                  <f.icon className="w-6 h-6" style={{ color: f.color }} strokeWidth={1.5} />
                </div>
                <h3 className="text-lg font-medium text-[#1E293B] mb-2">{f.title}</h3>
                <p className="text-sm text-[#64748B] leading-relaxed">{f.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
